export default "__VITE_ASSET__DIEsp8K$__"